module.exports = __webpack_public_path__ + "static/media/mobile-download.b257230a.png";